export interface Job {
  id: string
  title: string
  company: string
  employmentType: string
  city: string
  logoUrl: string
  headerImage: string
}

export interface Branding {
  primary: string
  accent: string
  ctaTextColor: string
  titleColor: string
  strokeColor: string
}

export interface CardData {
  job: Job
  brand: Branding
  displayTitle: string
  /** Label text above the title (e.g. "Wir suchen:"). */
  label?: string
  /** CTA button text (e.g. "Jetzt bewerben"). */
  ctaText?: string
  /** Subtitle text below the title. */
  subtitle?: string
  /** Optional manual override for the title font size (in px). */
  titleFontSize?: number
  /** Optional manual override for the info-row font size (in px). */
  infoFontSize?: number
  /**
   * Per-field font-size overrides (in px), keyed by the field's data-placeholder
   * id (e.g. "title", "city", "cta-text", or a custom key). When unset, the
   * template's own CSS size is used.
   */
  fontSizes?: Record<string, number>
  /** CTA button corner radius (in px). Default 15. */
  ctaRadius?: number
  /** Hero photo horizontal focal point (0–100, default 50). */
  photoOffsetX?: number
  /** Hero photo vertical focal point (0–100, default 50). */
  photoOffsetY?: number
  /** Hero photo zoom factor (1 = fit, >1 = zoomed in so offsets can pan). Default 1. */
  photoZoom?: number
  /** Whether the logo sits on a white panel. Default true. */
  logoOnPanel?: boolean
  /** Manual override for the logo render size (in px). */
  logoSize?: number
  /** If true, the hero photo is mirrored horizontally. */
  photoFlipH?: boolean
  /**
   * Values for template placeholders that aren't one of the built-in fields,
   * keyed by their data-placeholder id (e.g. "start-date"). Lets custom
   * templates expose extra inputs in the UI automatically.
   */
  customFields?: Record<string, string>
}

/**
 * data-placeholder ids handled by dedicated inputs/logic. Any other placeholder
 * in a template is treated as a generic custom text field.
 */
export const BUILT_IN_PLACEHOLDER_KEYS = [
  'title',
  'label',
  'subtitle',
  'city',
  'employment-type',
  'company',
  'cta-text',
  'logo',
  'header-image',
] as const

export type CardFormat = 'feed' | 'story'

export const DEFAULT_BRANDING: Branding = {
  primary: '#C2A676',
  accent: '#C2A676',
  ctaTextColor: '#FFFFFF',
  titleColor: '#222222',
  strokeColor: '#C2A676',
}

export const DEFAULT_JOB: Job = {
  id: '',
  title: '',
  company: '',
  employmentType: '',
  city: '',
  logoUrl: '',
  headerImage: '',
}

export const DEFAULT_CARD_DATA: CardData = {
  job: DEFAULT_JOB,
  brand: DEFAULT_BRANDING,
  displayTitle: '',
}

export interface ImageGeneratorOrderData {
  jobName?: string
  company?: string
  city?: string
  employmentType?: string
  logoUrl?: string
  headerImage?: string
}
